import React from 'react'
import Cookies from 'js-cookie'
import {connect} from 'react-redux'
import toast from '../lib/toast'

import MessageModal from './MessageModal'
import Login from './Login'
import ForgotPassword from '../components/ForgotPassword'
import {loggedOut, userAuthorised, forgotPassword} from '../actions/authActions'
import {logOut} from '../services/authSvc'
import {firebase} from '../services/dataSvc'
import {serviceRoot} from '../config'

// Map Firebase auth error codes to user-friendly messages
const getAuthErrorMessage = (errorCode) => {
    const errorMessages = {
        'auth/invalid-email': 'Please enter a valid email address.',
        'auth/user-disabled': 'This account has been disabled. Please contact support.',
        'auth/user-not-found': 'No account found with this email address.',
        'auth/wrong-password': 'Incorrect password. Please try again.',
        'auth/missing-password': 'Please enter your password.',
        'auth/invalid-credential': 'Invalid email or password. Please check your credentials.',
        'auth/too-many-requests': 'Too many failed attempts. Please try again later.',
        'auth/network-request-failed': 'Network error. Please check your connection and try again.',
        'auth/email-already-in-use': 'An account with this email already exists.',
        'auth/weak-password': 'Password is too weak. Please use at least 6 characters.',
        'auth/operation-not-allowed': 'This sign-in method is not enabled.',
        'auth/account-exists-with-different-credential': 'An account already exists with this email using a different sign-in method.'
    }
    return errorMessages[errorCode] || 'An error occurred. Please try again.'
}

//TODO: Change form handling to use Redux Forms
class Authenticate extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            emailReg: "",
            passwordReg: "",
            passwordConfirmReg: "",
            email: Cookies.get('lastLoginEmail') || "",
            password: "",
            resetPasswordEmail: "",
            recaptchaVerified: false,
            showRegistration: false
        }
    }

    componentDidMount = () => {
        const {isInvitePending} = this.props;

        if (isInvitePending) {
            toast.success('Welcome to shtum', 'Please register or login to accept the invite.')
        }

        // Load reCAPTCHA v3 script
        this.loadRecaptchaScript()
    }

    loadRecaptchaScript = () => {
        if (window.grecaptcha) return // Already loaded

        const script = document.createElement('script')
        script.src = 'https://www.google.com/recaptcha/api.js?render=6Ldp9w4sAAAAAItopPeye-ADkAuaZ7Z8aNN-9xyO'
        script.async = true
        script.defer = true
        document.head.appendChild(script)
    }

    toggleView = (e) => {
        if (e) e.preventDefault()
        this.setState(prevState => ({
            showRegistration: !prevState.showRegistration
        }))
    }
    handleRegEmailChange = (e) => {
        this.setState({emailReg: e.target.value});
    }
    handleRegPasswordChange = (e) => {
        this.setState({passwordReg: e.target.value});
    }
    handleRegPasswordConfirmChange = (e) => {
        this.setState({passwordConfirmReg: e.target.value});
    }
    handleRegister = (e) => {
        e.preventDefault();

        var emailReg = this.state.emailReg.trim();
        var passwordReg = this.state.passwordReg.trim();
        var passwordConfirmReg = this.state.passwordConfirmReg.trim();

        //TODO: Handle validation properly
        if (!emailReg || !passwordReg || !passwordConfirmReg) {
            this.refs.messageModal.showAlert({
                detail: "Please enter all fields"
            });

            return;
        }

        if (passwordReg !== passwordConfirmReg) {
            this.refs.messageModal.showAlert({
                detail: "Passwords do not match"
            });

            return;
        }

        if (passwordReg.length < 6) {
            this.refs.messageModal.showAlert({
                detail: "Passwords must be at least 6 characters"
            });

            return;
        }

        // Execute reCAPTCHA v3 before registering user
        if (window.grecaptcha) {
            window.grecaptcha.ready(() => {
                window.grecaptcha.execute('6Ldp9w4sAAAAAItopPeye-ADkAuaZ7Z8aNN-9xyO', {action: 'register'})
                    .then((token) => {
                        // Call secure registration endpoint
                        this.registerUser(emailReg, passwordReg, token);
                    })
                    .catch((error) => {
                        console.error('reCAPTCHA error:', error)
                        this.refs.messageModal.showAlert({
                            detail: "Security verification failed. Please try again."
                        });
                    })
            })
        } else {
            // Fallback if reCAPTCHA not loaded - show error
            this.refs.messageModal.showAlert({
                detail: "Security verification not available. Please refresh and try again."
            });
        }

    };

    registerUser = (email, password, token) => {
        const that = this;

        // Call secure backend endpoint that verifies reCAPTCHA and creates user
        fetch(serviceRoot + 'api/register', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                email: email,
                password: password,
                token: token
            })
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                // Sign in with the custom token returned by the server
                firebase.auth().signInWithCustomToken(data.token)
                    .then(() => {
                        // User is now signed in
                        console.log('User registered and signed in successfully');
                    })
                    .catch((error) => {
                        console.error('Sign-in error:', error);
                        that.refs.messageModal.showAlert({
                            detail: "Registration succeeded but sign-in failed. Please try logging in.",
                            className: 'alert-warning'
                        });
                    });
            } else {
                that.refs.messageModal.showAlert({
                    detail: data.message || "Registration failed. Please try again.",
                    className: 'alert-danger'
                });
            }
        })
        .catch((error) => {
            console.error('Registration error:', error)
            that.refs.messageModal.showAlert({
                detail: "Unable to complete registration. Please try again.",
                className: 'alert-danger'
            });
        })
    }

    render() {
        const { showRegistration } = this.state;

        return (
            <div className="shthum--auth-page authenticateContainer">
                <h1 className="brandTitleLogin shthum--auth-page-title text-center">shtum</h1>

                {!showRegistration ? (
                    <>
                        <div className="row">
                            <Login />
                        </div>
                        <div className="row">
                            <div className="col-xs-12 col-md-12">
                                <p className="shtum--auth-page-divider text-center">
                                    <a href="#" onClick={this.toggleView} className="shtum--auth-page-toggle-link">
                                        Create new account
                                    </a>
                                </p>
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="row">
                            <div className="col-xs-8 col-sm-6 col-md-4 col-xs-offset-2 col-sm-offset-3 col-md-offset-4 shthum--auth-page-register">
                                <form id="frmRegister" className="shtum--form-register" role="form" onSubmit={this.handleRegister} autoComplete="off">
                                    <div className="form-group">
                                        <input type="email" className="form-control shtum--form-input" id="emailReg" placeholder="Enter email"
                                               name="emailReg" autoComplete="email" onChange={this.handleRegEmailChange}/>
                                    </div>
                                    <div className="form-group">
                                        <input type="password" className="form-control shtum--form-input" id="new-password" placeholder="Password"
                                               name="new-password" autoComplete="new-password" onChange={this.handleRegPasswordChange}/>
                                    </div>
                                    <div className="form-group">
                                        <input type="password" className="form-control shtum--form-input" id="confirm-password"
                                               placeholder="Confirm Password" name="confirm-password"
                                               autoComplete="new-password" onChange={this.handleRegPasswordConfirmChange}/>
                                    </div>
                                    <div className="text-right">
                                        <button type="submit" className="btn shtum--btn shtum--btn_green">Sign Up</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12 col-md-12">
                                <p className="shtum--auth-page-divider text-center">
                                    <a href="#" onClick={this.toggleView} className="shtum--auth-page-toggle-link">
                                        Back to login
                                    </a>
                                </p>
                            </div>
                        </div>
                    </>
                )}

                <div className="row">
                    <div className="col-xs-12 col-md-12">
                        <ul className="list list-horizontal shtum--auth-page-list">
                            <li><a href="">unfollow</a></li>
                            <li><a href="">defriend</a></li>
                            <li><a href="">keep shtum</a></li>
                        </ul>
                    </div>
                </div>

                <div className="modal fade shtum--modal" id="messageModal" tabIndex="-1" role="dialog">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-body errMessage">
                                <h4 id="message" className="text-center"></h4>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn shtum--btn shtum--btn_red" data-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>

                <MessageModal ref='messageModal'/>

                <ForgotPassword />

            </div>)
    }
}

const mapStateToProps = (state) => {
    let auth = state.auth

    return {
        isAuthorised: auth.isAuthorised,
        email: auth.email,
        uid: auth.uid,
        isInvitePending: checkIfInviteIsPending(state)
    }
};

function checkIfInviteIsPending(state) {
    let board = state.board

    var isInvitePending = false
    if (board.invite)
        isInvitePending = board.invite.invitePending
    return isInvitePending;
}

const mapDispatchToProps = (dispatch) => {
    return {
        onLogOut: () => {
            logOut();
            dispatch(loggedOut());
        },
        onUserAuthorised: (email, uid) => {
            dispatch(userAuthorised(email, uid));
        },
        onForgotPassword: (email) =>
            dispatch(forgotPassword(email))
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Authenticate);
